import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        const stored = localStorage.getItem("theme");
        return stored === "0" ? 0 : 1;
    });
    useEffect(() => {
        document.body.classList.remove("light", "dark");
        document.body.classList.add(theme === 0 ? "dark" : "light");
        localStorage.setItem("theme", theme.toString());
    }, [theme]);
    const toggleTheme = () => {
        setTheme(prev => (prev === 0 ? 1 : 0));
    };
    useEffect(() => {
        const handleStorage = (e) => {
            if (e.key === "theme" && (e.newValue === "0" || e.newValue === "1")) {
                setTheme(parseInt(e.newValue, 10));
            }
        };

        window.addEventListener("storage", handleStorage);
        return () => window.removeEventListener("storage", handleStorage);
    }, []);
    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
